export enum UserGroup {
	NHSSAA = 'nhssaa',
}
